import { Injectable } from '@angular/core';
import { AvantoLambdaService } from './avanto-lambda.service';
import { Customer } from '../avantoeats-util/models/customer/Customer';
import { CustomerLastOrders } from '../avantoeats-util/models/customer/CustomerLastOrders';

@Injectable({
  providedIn: 'root'
})
/**
 * Deals with information regarding the user that's currently logged in, such as his saved credit card information, his last orders 
 * and the list of addresses he uses to make his orders
 */
export class AvantoCustomerService {

  constructor(private lambdaService: AvantoLambdaService) { }

  /**
   *  Gets the customer from the database.
   * @param cognitoId ID of this used on cognito. Is used as a primary key for our customer table.
   * @param getLastOrders if true, will also get the last orders done by this user
   */
  getCustomer(cognitoId, getLastOrders?) {
    return new Promise<{ customer: Customer, lastOrders: CustomerLastOrders[] }>((resolve, reject) => {

      this.lambdaService.fetchCustomerInformation(cognitoId, getLastOrders).subscribe((response) => {
        if (response.ok) {
          //Converts the customer retrieved from amazon into an object and fires the session subject
          const retrievedData = response.json().data;

          const retrievedCustomer = Customer.newFromAws(retrievedData.awsCustomer);

          const retrievedLastOrders: CustomerLastOrders[] = [];
          retrievedData.awsLastOrders.forEach(lo => {
            retrievedLastOrders.push(CustomerLastOrders.newFromAws(lo))
          });

          resolve({ customer: retrievedCustomer, lastOrders: retrievedLastOrders });
        } else {
          console.error("Unable to get the customer: ", response)
          reject();
        }
      },
        (error) => {
          console.error("Error while trying to update the customer: ", error)
          reject();
        });
    })
  }

  updateForNewOrder(saveOrderResponse: any) {
    saveOrderResponse["APIVersion"] = 1;
    return new Promise<{showCampaignToCustomerAtCheckout:string}>((resolve, reject) => {
      this.lambdaService.updateCustomerForNewOrder(saveOrderResponse).subscribe((response) => {
        if (response.ok) {
          resolve(response.json().data);
        } else {
          console.error("Unable to update the customer with the information from the new order: ", response)
          reject();
        }
      },
        (error) => {
          console.error("Error while updating the customer with the information from the new order: ", error)
          reject();
        });
    })
  }
}